// §29.12 / §9.1 — Pulse as an in-process app.
//
// Manifest only (D-247): the engine, the view, the CSS and the sprite sheet all live behind the
// thunk, so a desktop that never opens this window never downloads any of it (D-199, D-367).
//
// Not a factory. Pulse is single-player — §30.1's multiplayer allowlist does not name it — so it
// needs no `PlayShellAccess` and taking one would imply a session it never opens.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createPulseApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'pulse',
      name: 'Pulse',
      // §29.1 (D-379) — the glyph is fixed by the roster, not chosen here.
      icon: { glyph: 'activity', hue: 285 },
      keywords: ['rhythm', 'music', 'runner', 'one button', 'practice', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      // §29.1 (D-369) — the fourth sub-group, and the only title in it.
      group: 'Rhythm',
      requiresAuth: true,
      // Fixed-aspect letterboxed canvas (D-229, D-374). The runner is fixed on screen and the
      // level scrolls past it, so the window's width *is* how much warning you get — a stretched
      // one would make a level the compiler proved passable read as easier or harder by accident.
      window: { width: 820, height: 620, minWidth: 520, minHeight: 400, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        // §29.12 — practice is a mode, and the jump list is where a mode belongs (§9.3).
        { id: 'practice', label: 'Practice mode' },
      ],
    },
    load: () => import('./Pulse'),
  });
}
